<template>
    <div>
        <div style="margin:4px;">
            <div style="display:inline;border-right:1px solid gray;padding:4px;">

                <router-link to="/cart">
                    <span v-if="hasLogin" class="btn btn-primary">
                        <span class="glyphicon glyphicon-shopping-cart"></span> {{lang.navi.cart}}
                    </span>
                </router-link>


                <router-link to="/wishList">
                    <span v-if="!hasLogin" class="btn btn-primary">
                        <span class="glyphicon glyphicon-shopping-cart"></span> {{lang.navi.wishList}}
                    </span>
                </router-link>

            </div>
            <div style="display:inline;">
                <div style="display:inline;">
                    <iframe style="max-height:34px;max-width:100px;overflow-x:hidden;overflow-y:hidden;" 
                            class="btn btn-default" 
                            :src="fbShareUrl">
                    </iframe>
                </div>
                <div v-if="hasShareApi" style="display:inline;">
                    <div class="btn btn-default" @click="shareClick()">
                        {{lang.common.share}} <span class="glyphicon glyphicon-share"></span>
                    </div>
                </div>
                <div class="btn btn-default copy-url-to-share" @click="copyToClipBoard2()">
                    {{lang.common.copyUrl}} <span class="glyphicon glyphicon-copy"></span>
                </div>
                <textarea ref="toShareContent" arial-hidden="true" readonly="" style="height: 1px; width: 1px; border: none; background-color: transparent; color: transparent; resize: none; position: absolute; left: -99999px; top: 0;">{{currentPageUrl}}</textarea>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        computed: {
            lang: function () {
                return this.$store.getters.lang;
            },
            hasLogin: function () {
                return this.$store.getters.account !== null;
            },
            hasShareApi: function () {
                return window.navigator.share;
            },
            fbShareUrl: function () {
                return this.mxnAgxApi.apiClient.getFbShareUrl(this.currentPageUrl);
            }
        },
        data: function () {
            return {
                showFbkShare: false,
                currentPageUrl: window.location.href
            }
        },
        methods: {
            copyToClipBoard2: function () {
                var elm = this.$refs.toShareContent;
                elm.select();
                elm.setSelectionRange(0, 99999);
                document.execCommand("copy");
            },
            shareClick: function () {
                if (this.hasShareApi) {
                    navigator.share({
                        title: '',
                        url: this.currentUrl
                    }).then(() => {
                        console.log('Thanks for sharing!');
                    }).catch(console.error);

                } else {
                    // fallback
                    console.log('sharing not supported');
                }
            }
        },
        watch: {
            '$route'() {
                this.currentPageUrl = window.location.href;
            }
        },
        created: function () {
            
        }
    }
</script>
